<section class="col-seleccion enLocalizador enAmigosThyssen">
  <div
    div
    class="ticket-info filtros-tipos"
    [formGroup]="filtrosForm"
    *ngIf="tiposProducto && tiposProducto.length > 1 && verSelectores"
  >
    <div class="inputControl">
      <select
        formControlName="tipoproducto"
        (change)="cambiodeFiltro($event.target, 'TP')"
      >
        <!--<option disabled value ="">Filtrar por tipo</option>-->
        <option value="">
          {{ 'TIPO' | translateV2 }}
        </option>
        <option
          *ngFor="let tipoProducto of tiposProducto"
          [value]="tipoProducto.Cod"
        >
          {{ tipoProducto.Desc }}
        </option>
      </select>
      <div
        class="closefilter"
        [ngStyle]="{
          visibility: filtradoPorProducto === '' ? 'hidden' : 'visible',
          opacity: filtradoPorProducto === '' ? 0 : 1
        }"
      >
        <a title="cerrar" (click)="eliminarFiltro($event.target, 'TP')"
          ><span class="cross"></span><span class="sr-only">eliminar</span></a
        >
      </div>
    </div>
    <div class="inputControl">
      <select
        formControlName="rangoedad"
        (change)="cambiodeFiltro($event.target, 'RE')"
      >
        <!--<option disabled value ="">Filtrar por rango de edad</option>-->
        <option value="">
          {{ 'RANGO_EDAD' | translateV2 }}
        </option>
        <option *ngFor="let grupo of gruposAsociados" [value]="grupo.Cod">
          {{ grupo.Desc }}
        </option>
      </select>
      <div
        class="closefilter"
        [ngStyle]="{
          visibility: filtradoPorGrupoAso === '' ? 'hidden' : 'visible',
          opacity: filtradoPorGrupoAso === '' ? 0 : 1
        }"
      >
        <a title="cerrar" (click)="eliminarFiltro($event.target, 'RE')"
          ><span class="cross"></span><span class="sr-only">eliminar</span></a
        >
      </div>
    </div>
    <div class="inputControl">
      <select
        formControlName="tiponivel"
        (change)="cambiodeFiltro($event.target, 'TN')"
      >
        <!--<option disabled value ="">Fitrar por nivel</option>-->
        <option value="">
          {{ 'NIVEL' | translateV2 }}
        </option>
        <option *ngFor="let nivel of tiposNivel" [value]="nivel.Cod">
          {{ nivel.Cod }}
        </option>
      </select>
      <div
        class="closefilter"
        [ngStyle]="{
          visibility: filtradoPorNivel === '' ? 'hidden' : 'visible',
          opacity: filtradoPorNivel === '' ? 0 : 1
        }"
      >
        <a title="cerrar" (click)="eliminarFiltro($event.target, 'TN')"
          ><span class="cross"></span><span class="sr-only">eliminar</span></a
        >
      </div>
    </div>

    <!--<button
      type="button"
      value="+"
      class="SiguienteButton"
      (click)="enviarFiltros()"
    >
      {{ 'APLICAR FILTRO' | translate }}
    </button>-->
  </div>
  <div
    *ngIf="tienePermiso('filtroPorNombre')"
    class="ticket-info filtros-tipos"
    [formGroup]="filtrosTextForm"
  >
    <div class="inputControl sizebuscador">
      <input
        class="cliente"
        formControlName="busqueda"
        type="text"
        placeholder="{{ 'BUSCAR' | translate }}"
        (input)="cambiodeFiltroTexto()"
      />
      <div
        class="closefilter"
        [ngStyle]="{
          visibility: filtradoPorNombre === '' ? 'hidden' : 'visible',
          opacity: filtradoPorNombre === '' ? 0 : 1
        }"
      >
        <a
          title="{{ 'CERRAR' | translate }}"
          (click)="eliminarFiltro($event.target, 'N')"
          ><span class="cross"></span><span class="sr-only">eliminar</span></a
        >
      </div>
    </div>
    <div
      class="flechasBuscardor"
      [ngStyle]="{
        visibility: filtradoPorNombre === '' ? 'hidden' : 'visible',
        opacity: filtradoPorNombre === '' ? 0 : 1
      }"
    >
      <a class="flechaUp" (click)="filroCategoriaPrevio()">Anterior</a>
      <a class="flechaDown" (click)="filroCategoriaSiguiente()">Siguiente</a>
    </div>
  </div>
  <div class="wrap-tabs-seleccion">
    <perfect-scrollbar class="tabs-seleccion ps--active-y cat-scrollbar" [config]="config">
      <ul *ngIf="categorias">
        <li
          *ngFor="let cat of categorias"
          [ngClass]="{
            active: categoriaActiva && categoriaActiva.pkId === cat.pkId,
            destacada: deberiaDestacarse(cat.pkId)
          }"
          (click)="mostrarSubcategorias(cat)"
        >
          <a>{{ cat.nombre }}</a>
        </li>
      </ul>
    </perfect-scrollbar>
    <!--<perfect-scrollbar class="tabs-seleccion ps--active-y cat-scrollbar" [config]="config">

      <ul *ngIf="categorias">
        <li
          *ngFor="let subcat of subcategoriasSeleccionadas"
          (click)="mostrarSubcategorias(subcat, false, true)"
        >
          <a>{{ subcat.nombre }}</a>
        </li>
      </ul>
    </perfect-scrollbar>-->
    <div id="tabs-content">
      <div id="tabSel-01">
        <div class="Rtable">
          <div class="Rtable-row Rtable-row--head">
            <div class="Rtable-cell item-cell column-heading">
              {{ 'ITEM' | translate }}
            </div>
            <div class="Rtable-cell precio-cell column-heading">
              {{ 'PRECIO' | translate }}
            </div>
            <div class="Rtable-cell cantidad-cell column-heading">
              {{ 'CANTIDAD' | translate }}
            </div>
          </div>
          <div class="listado">
            <div *ngIf="entradas && entradas.length > 0">
              <div
                class="Rtable-row"
                [ngClass]="{
                  active: getCantidadPorEntrada(entrada) > 0,
                  selected: entradaSeleccionada === entrada
                }"
                (click)="seleccionarEntrada(entrada)"
                *ngFor="let entrada of pagedItems"
              >
                <div class="Rtable-cell item-cell">
                  <div class="Rtable-cell--content item-content">
                    {{ entrada.NombrePantalla }}
                  </div>
                </div>
                <div
                  class="Rtable-cell precio-cell"
                  [ngClass]="{ 'large-cell': esGranDivisa }"
                >
                  <div class="Rtable-cell--content precio-content">
                    <span>
                      {{
                        entrada.PrecioEnDivisaReferencia
                          | myCurrency
                            : divisaSimboloDecimal
                            : divisaDecimales
                            : divisaPosicion
                            : divisaSimbolo
                            : divisaSimboloDerecha
                            : divisaSimbSeparacionMiles
                      }}
                    </span>
                  </div>
                </div>
                <div class="Rtable-cell Rtable-cell--foot cantidad-cell">
                  <div class="Rtable-cell--content cantidad-content">
                    <div class="quantity">
                      <button
                        type="button"
                        value="-"
                        class="addValueButton minus"
                        (click)="eliminarEntrada(entrada)"
                      >
                        -
                      </button>
                      <input
                        [disabled]="entrada.noEditable || verSelectores"
                        id="{{ entrada.idTarifa }}"
                        type="number"
                        class="qty text"
                        step="1"
                        min="0"
                        name="quantity"
                        category="CANTIDAD"
                        [value]="getCantidadPorEntrada(entrada)"
                        (focus)="focusValue($event, entrada)"
                        (blur)="unfocusValue($event)"
                        (keydown)="inputDeTeclado($event, entrada)"
                        title="Cantidad"
                        size="4"
                      />
                      <button
                        type="button"
                        value="+"
                        class="addValueButton plus"
                        (click)="agregarEntrada(entrada)"
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ul
            class="pagination"
            *ngIf="pager.pages && pager.pages.length > 1 && entradas.length > 0"
          >
            <li>
              <a (click)="setPage(pager.currentPage - 1)" title="Previo">
                <img
                  class="svg"
                  src="assets/img/active-arrow.svg"
                  alt="icono prev"
                />
              </a>
            </li>
            <li *ngFor="let page of pager.pages">
              <a
                (click)="setPage(page)"
                [ngClass]="{ active: pager.currentPage === page }"
                >{{ page }}</a
              >
            </li>
            <li>
              <a (click)="setPage(pager.currentPage + 1)" title="Próximo">
                <img
                  class="svg"
                  src="assets/img/active-arrow.svg"
                  alt="icono next"
                />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
